import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

export default class SupplierNotificationsPage extends React.Component<any, null> {
	render() {
		return (
			<div>
				<Route
					path="/supplier/inbox"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/inbox/overview',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
